import {
    RETURN_REFUND_BY_DAY_SUCCESS,
    RETURN_REFUND_BY_DAY_LOADING
} from '../actions/ReturnRefundByDayAction';

const initialState = {
    returnRefundByDayData: null,
    isLoading: true    
};

const returnRefundByDay = (state = initialState, action = {}) => {

    switch (action.type) {
        case RETURN_REFUND_BY_DAY_SUCCESS:
            return {
                ...state,  returnRefundByDayData: action.data, isLoading: false 
            };
        case RETURN_REFUND_BY_DAY_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default returnRefundByDay;
